//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import { GalleriesCustomizationActionType } from '@galleries/actions/galleriesCustomizationActions';
import { GALLERIES_ACTIONS } from '@galleries/constants/galleriesConstants';
import { IGalleriesCustomizationModal } from '@galleries/models/galleriesStateModel';

const initialState: IGalleriesCustomizationModal = {
  isModalOpen: false,
  isLocalizationAlertHidden: true,
  showValidationStatus: false,
};

export default function GalleriesCustomizationReducer(
  state: IGalleriesCustomizationModal = initialState,
  action: GalleriesCustomizationActionType,
): IGalleriesCustomizationModal {
  switch (action.type) {
    case GALLERIES_ACTIONS.OPEN_CUSTOMIZE_GALLERY_MODAL: {
      return {
        ...state,
        isModalOpen: true,
      };
    }
    case GALLERIES_ACTIONS.CLOSE_CUSTOMIZE_GALLERY_MODAL: {
      return {
        ...state,
        isModalOpen: false,
      };
    }

    case GALLERIES_ACTIONS.SHOW_LOCALIZATION_SAVE_WARNING: {
      return {
        ...state,
        isLocalizationAlertHidden: false,
      };
    }

    case GALLERIES_ACTIONS.CLEAR_LOCALIZATION_SAVE_WARNING: {
      return {
        ...state,
        isLocalizationAlertHidden: true,
      };
    }
    case GALLERIES_ACTIONS.SHOW_CUSTOMISATIONPANEL_ERROR_STATUS: {
      return {
        ...state,
        showValidationStatus: true,
      };
    }
    case GALLERIES_ACTIONS.HIDE_CUSTOMISATIONPANEL_ERROR_STATUS: {
      return {
        ...state,
        showValidationStatus: false,
      };
    }
    default:
      return state;
  }
}
